// AutoGenerated
export class GuidRequestModel {
    constructor(
        id: string,
    ) {
        this.id = id;
    }

    id: string;
}